import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, type CSSResult } from 'lit'

export const hostStyle: CSSResult = css`
  .content {
    display: flex;
    flex-direction: column;
    gap: var(--csc-delivery-match-methods-gap, ${csSpacing.spacing04});
  }

  .content.inline {
    flex-direction: row;
  }

  @media (max-width: ${SCREENS.small}) {
    .content.inline {
      flex-direction: column;
    }
  }

  .content.inline cse-skeleton,
  .content.inline cse-selectable {
    flex: 1;
  }
`
